import { utils } from "near-api-js";
import regeneratorRuntime from "regenerator-runtime";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Header from "../components/Header";
import Landing from "../components/Landing";
import { ToastContainer } from "react-toastify";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Admin from "./Admin";
const darkTheme = createTheme({
	typography: {
		h3: {
			fontFamily: "Source Sans Pro",
			fontWeight: "700",
		},
		fontFamily: "Source Sans Pro",
	},

	palette: {
		mode: "dark",
		primary: {
			main: "#EBAD55",
			light: "#90f2f7",
		},
		secondary: {
			main: "#fbf9f8",
		},
		background: {
			default: "#3b5776",
			paper: "#181818",
		},
		warning: {
			main: "#ff3d00",
		},
		text: {
			primary: "#EBAD55",
		},
	},
});
const Home = () => {
	return (
		<ThemeProvider theme={darkTheme}>
			<div className="home">
				<Header />

				<BrowserRouter>
					<Routes>
						<Route path="/" exact element={<Landing />} />

						<Route path="/admin" element={<Admin />} />
					</Routes>
				</BrowserRouter>
				<ToastContainer />
			</div>
			<CssBaseline />
		</ThemeProvider>
	);
};

export default Home;
